export default __webpack_public_path__ + "static/compareItemImg3-b6696f54bb2a581f7afeea66f75f987d.webp";